import { Alert, styled } from '@mui/material';
import { WarningBarVariant } from './types';

export const WarningAlertStyled = styled(Alert, {
  shouldForwardProp: prop => prop !== 'barVariant',
})<{ barVariant: WarningBarVariant }>(({ theme, barVariant }) => ({
  color: barVariant === 'info' ? theme.palette.info.contrastText : '#FF981F',
  background: barVariant === 'info' ? theme.palette.info.main : '#FFF4E5',
  minHeight: '48px',
  display: 'flex',
  '.MuiAlert-message': {
    display: 'flex',
    alignItems: 'center',
  },
}));
